import SEO from "../components/SEO";
import PageSeoOverride from "../components/PageSeoOverride";
import { SITE, DEALER, SALES } from "../data/constants";
import { useContent } from "../lib/ContentContext";
import { useSettings } from "../lib/SettingsContext";
import ReactMarkdown from "react-markdown";

export default function PrivacyPolicy() {
  const { t } = useContent();
  const { settings } = useSettings();
  const dealerName = settings.dealer_name || DEALER.name;
  const address = settings.dealer_address || DEALER.address;
  const salesName = settings.sales_name || SALES.name;
  const salesTitle = settings.sales_title || SALES.title;
  const phone = settings.sales_phone || SALES.phone;
  const domain = settings.site_domain || SITE.domain;

  const bodyMd = (
    t(
      "privacy.body_md",
      "## 1. Tentang Dokumen Ini\nDokumen ini menjelaskan kebijakan privasi website **{domain}** yang dioperasikan oleh **{dealer}**."
    ) || ""
  )
    .replace(/\{domain\}/g, domain)
    .replace(/\{dealer\}/g, dealerName)
    .replace(/\{address\}/g, address)
    .replace(/\{sales\}/g, salesName)
    .replace(/\{title\}/g, salesTitle)
    .replace(/\{phone\}/g, phone);

  return (
    <>
      <SEO
        title="Kebijakan Privasi | Dealer BYD Cibubur"
        description="Kebijakan privasi Dealer BYD Haka Auto Cibubur — bagaimana kami menangani data, penggunaan nomor WhatsApp, dan cookie website."
        canonical={`${SITE.domain}/kebijakan-privasi`}
      />
      <PageSeoOverride pageKey="privacy" />
      <article className="max-w-3xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
        <p className="text-xs uppercase tracking-[0.25em] text-[#6E6E73] mb-5">
          {t("privacy.eyebrow", "Legal · Privasi")}
        </p>
        <h1 className="text-4xl sm:text-5xl font-medium tracking-tight text-[#0F0F0F] leading-[1.05]">
          {t("privacy.heading", "Kebijakan Privasi")}
        </h1>
        <p className="mt-4 text-sm text-[#86868B]">
          {t("privacy.last_updated", "Terakhir diperbarui: 1 Februari 2026")}
        </p>

        <div className="mt-10 text-[#1A1A1A] leading-relaxed text-base [&_h2]:text-xl [&_h2]:font-medium [&_h2]:text-[#0F0F0F] [&_h2]:mt-10 [&_h2]:mb-3 [&_p]:my-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_strong]:text-[#0F0F0F]">
          <ReactMarkdown>{bodyMd}</ReactMarkdown>
        </div>
      </article>
    </>
  );
}
